import { render } from "./DispatchList.vue?vue&type=template&id=7487fef8&scoped=true"
import script from "./DispatchList.vue?vue&type=script&lang=js"
export * from "./DispatchList.vue?vue&type=script&lang=js"

import "./DispatchList.vue?vue&type=style&index=0&id=7487fef8&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4197/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7487fef8"]])

export default __exports__